import React, {useState} from 'react'
import Header from 'components/container/nav/Header'
import MainMenu from 'components/container/nav/MainMenu'
import cn from 'classnames'
import * as styles from './default.module.css'

const DefaultLayout = ({ children, location }) => {
  const [ state, setState ] = useState({
    open: false,
  })

  function changeMeunOpenState(isOpen) {
    setState({
      ...state,
      open: isOpen,
    })
  }

  return (
    <div className={cn(styles.mainLayout)}>
      <MainMenu 
        className={cn(styles.leftSection)}
        location={location}
        onToggle={(isOpen) => changeMeunOpenState(isOpen)}
        open={state.open} />
      <div className={cn(styles.rightSection)}>
        <Header onMenuClick={() => changeMeunOpenState(true)} />
        {children}
      </div>
    </div>
  )
}




export default DefaultLayout